declare var _APP_CONFIG_: Config;

class Config {
  public specialsApiUrl:string;
  public translationUrl:string;
  public countryUrl:string;
  public loyaltyServiceUrl:string;
  public customerServiceUrl:string;
  public defaultLang:string;
  public buildVersion:string;
  public competitionServiceUrl:string;
  public analyticsTrackingId:string;
  public clickAndMeetServiceUrl:string;
  public productServiceUrl: string;
  public imageServiceUrl: string;
  public assetsServiceUrl:string;
  public formServiceUrl:string;
  public dressFmUrl:string;
}

export default _APP_CONFIG_;
window['NY_CONFIG'] = _APP_CONFIG_;
